import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
	selector: 'app-input-number-component',
	templateUrl: './input-number.component.html'
})
export class InputNumber {

	@Output() public valueChange = new EventEmitter<{ fieldName: string, value: number }>()

	@Input() public placeHolder: string = ''
	@Input() public inputId: string = ''
	@Input() public inputValue: string = ''
	@Input() public decimalPlacesBeforePoint: number = 0
	@Input() public decimalPlacesAfterPoint: number = 0
	@Input() public disabledInput: boolean = false
	@Input() public classInput: string = ''
	public valueReturn: number = 0

	public inputBlur() {
		const inputHtml = document.getElementById(this.inputId) as HTMLInputElement

		let valueInput = inputHtml.value

		const parts = valueInput.split('.')
		const twoParts = parts.length == 2

		const lastChar: string = valueInput[valueInput.length - 1]

		if (lastChar == '.') {
			valueInput += '00'
		} else if (twoParts) {
			if (parts[1].length < 2) {
				parts[1] = parts[1] += '0'
			}

			valueInput = `${parts[0]}.${parts[1]}`
		}

		inputHtml.value = valueInput

		this.inputReturn(valueInput)
	}

	public inputFormatNumber(event: string) {

		let valueInput: string = ''
		valueInput = this.validateNumber(event)
		valueInput = this.validateLastChar(valueInput)
		valueInput = this.validateDecimalParts(valueInput)

		const inputHtml = document.getElementById(this.inputId) as HTMLInputElement

		inputHtml.value = valueInput

		this.inputReturn(valueInput)
	}

	public validateNumber(input: string): string {

		const caractersValid = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ',']

		let countPoint: number = 0

		let stringReturn = ''

		for (const char of input) {
			const charValid: boolean = caractersValid.includes(char)
			const charIsPointOrComma: boolean = Boolean(char == '.' || char == ',')

			if (charValid && charIsPointOrComma) {
				if (countPoint > 0) {
					continue
				} else {
					countPoint++
					stringReturn += char
				}
			} else if (charValid) {
				stringReturn += char
			}
		}

		return stringReturn
	}

	public validateLastChar(input: string): string {

		const lastChar: string = input[input.length - 1] ? input[input.length - 1] : ''
		const lastCharIsPointOrComma: boolean = Boolean(lastChar == '.' || lastChar == ',')

		let stringReturn = input

		if (lastCharIsPointOrComma) {
			stringReturn = stringReturn.slice(0, -1)

			if (!stringReturn.includes('.')) {
				stringReturn += '.'
			}
		}

		return stringReturn
	}

	public validateDecimalParts(input: string): string {

		const parts = input.split('.')
		const twoParts = parts.length == 2
		const lengthNumber = input.length > this.decimalPlacesBeforePoint
		const lastCharIsPoint: boolean = Boolean(input == '.')

		let stringReturn = input

		if (!twoParts && lengthNumber) {

			if (!lastCharIsPoint) {
				stringReturn = stringReturn.slice(0, -1)
			}
		}

		if (twoParts) {
			if (parts[0] == '') {
				parts[0] = '0'
			}

			if (parts[1].length > this.decimalPlacesAfterPoint) {
				parts[1] = parts[1].substring(0, 2)
			}

			stringReturn = `${parts[0]}.${parts[1]}`
		}

		return stringReturn
	}

	public inputReturn(value: string) {
		const valueConvert = Number(value)

		if (!isNaN(valueConvert)) {
			this.valueReturn = valueConvert
		}

		this.valueChange.emit({ fieldName: this.inputId, value: this.valueReturn })
	}
}
